exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".el-avatar[data-v-2b23631c]{border:1px solid #dfe1e6;border-radius:3px;background-color:#fff}", ""]);

